import {Component, HostBinding, OnInit} from '@angular/core';
import {ServiceAnswer} from '../../../shared/service-answer';
import {_} from '~shared/utils';

@Component({
  selector: 'qm-loading-error',
  templateUrl: './loading-error.component.html',
  styleUrls: ['./loading-error.component.scss']
})
export class LoadingErrorComponent implements OnInit {

  @HostBinding('class') classes = 'loading-container';

  public answer: ServiceAnswer<any>;
  public errorMsg = _('Request failed. Please try again later...');

  constructor() { }

  ngOnInit() {
  }

}
